module.exports = __webpack_public_path__ + "static/media/scape.8895356f.png";